import React from 'react';
import css from './Credentials.scss';
import SortableTable from 'SF/table/SortableTable';
import CredentialRow from './CredentialRow';
import PropTypes from 'prop-types';


const Credentials = (props) => {

    const getHeaders = () => {
        const headers = [];
        headers.push({content: 'Credential'}, {content: 'Include in model and predictions?', textAlign: "center"});
        return headers;
    };

    const renderCredential = (credential, index) => {
        credential.onChange = props.onChange
        return <CredentialRow {...credential}
                              key={index}/>;
    }

    const getCredentialsTable = () => {
        if (typeof props.credentialsList === 'undefined' || props.credentialsList.length === 0 ||
            !Array.isArray(props.credentialsList))
            return <div
            className={css['no-credentials']}>No credentials available</div>;
        return (
            <SortableTable columnToSort="credential"
                           headers={getHeaders()}
                           items={props.credentialsList}
                           shouldPaginate={false}
                           renderItem={renderCredential}/>
        );
    };

    return (
        <div className={css['credential-table']}>
            {getCredentialsTable()}
        </div>
    );
}
Credentials.propTypes = {
    credentialsList: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func.isRequired

};

export default Credentials;
